import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useEmbedding } from '@/components/embed-provider';

export const EmbedRedirectGuard = ({ children }: { children: ReactNode }) => {
  const { embedState } = useEmbedding();
  const isInIframe = window.self !== window.top;

  if (embedState.kizeoEmbed?.isActive || isInIframe) {
    return <Navigate to="/embed/kizeo" replace />;
  }

  return children;
};
